import { NotificationType } from '../components/base/notifications/Notification';
import { ActionType } from '../constants/ActionTypes'

export default function notificationsReducer(state = {}, action = {}) {
    switch (action.type) {
        case ActionType.DISPATCH_NOTIFICATION:
            const notificationsList = action.payload.messageType === NotificationType.Close ?
                //close By Id
                action.payload.id ? state.notificationsList.filter(message => message.id !== action.payload.id) :
                    //close By Close By Type
                    action.payload.type ? state.notificationsList.filter(message => message.type !== action.payload.type) :
                        //close All
                        [] :
                //add to list
                [...state.notificationsList, {
                    message: action.payload.message,
                    type: action.payload.messageType,
                    id: action.payload.id
                }]
            return {
                ...state,
                notificationsList
            }
        case ActionType.DISPATCH_ALERT:
            const { placement = `bottom-right`, size = `medium`, isVisible, className = '', icon = false, message, title } = action?.payload;
            return {
                ...state,
                alert: {
                    placement,
                    size,
                    icon,
                    className,
                    isVisible,
                    message,
                    title
                }
            }
        default:
            return state;
    }
}
